/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Schema Registry API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateSchemaObject400,
  GetAllSchemaObjectsParams,
  GetGraphPromotedProperties200,
  GetSchemaObjectByVersionParams,
  GetSchemaObjectViewsParams,
  GetSpecializationFamily200,
  PromoteRelease202,
  Relationship,
  RelationshipConstraintsRequest,
  Relationships,
  SchemaObject,
  TypeMatrix,
  UiLens,
  UiLensDraft,
  UpdateSchemaObjectByVersion200,
  UpdateSchemaObjectByVersionParams,
  ViewList,
} from "../model";

import { customFetch } from "../../../custom-fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getAllSchemaObjectsResponse200 = {
  data: SchemaObject[];
  status: 200;
};

export type getAllSchemaObjectsResponseSuccess = getAllSchemaObjectsResponse200 & {
  headers: Headers;
};
export type getAllSchemaObjectsResponse = getAllSchemaObjectsResponseSuccess;

export const getGetAllSchemaObjectsUrl = (params?: GetAllSchemaObjectsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/schema-registry-service/v1/schema?${stringifiedParams}`
    : `/schema-registry-service/v1/schema`;
};

/**
 * @summary Get all schemas
 */
export const getAllSchemaObjects = async (
  params?: GetAllSchemaObjectsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getAllSchemaObjectsResponse> => {
  return customFetch<getAllSchemaObjectsResponse>(getGetAllSchemaObjectsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAllSchemaObjectsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAllSchemaObjects>>,
    TError,
    { params?: GetAllSchemaObjectsParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAllSchemaObjects>>,
  TError,
  { params?: GetAllSchemaObjectsParams },
  TContext
> => {
  const mutationKey = ["getAllSchemaObjects"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAllSchemaObjects>>,
    { params?: GetAllSchemaObjectsParams }
  > = (props) => {
    const { params } = props ?? {};

    return getAllSchemaObjects(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAllSchemaObjectsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAllSchemaObjects>>
>;

export type GetAllSchemaObjectsMutationError = unknown;

/**
 * @summary Get all schemas
 */
export const useGetAllSchemaObjects = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAllSchemaObjects>>,
      TError,
      { params?: GetAllSchemaObjectsParams },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getAllSchemaObjects>>,
  TError,
  { params?: GetAllSchemaObjectsParams },
  TContext
> => {
  return useMutation(getGetAllSchemaObjectsMutationOptions(options), queryClient);
};
export type createSchemaObjectResponse201 = {
  data: SchemaObject;
  status: 201;
};

export type createSchemaObjectResponse400 = {
  data: CreateSchemaObject400;
  status: 400;
};

export type createSchemaObjectResponseSuccess = createSchemaObjectResponse201 & {
  headers: Headers;
};
export type createSchemaObjectResponseError = createSchemaObjectResponse400 & {
  headers: Headers;
};

export type createSchemaObjectResponse =
  | createSchemaObjectResponseSuccess
  | createSchemaObjectResponseError;

export const getCreateSchemaObjectUrl = () => {
  return `/schema-registry-service/v1/schema`;
};

/**
 * @summary Create a new schema
 */
export const createSchemaObject = async (
  schemaObject: SchemaObject,
  options?: Parameters<typeof customFetch>[1],
): Promise<createSchemaObjectResponse> => {
  return customFetch<createSchemaObjectResponse>(getCreateSchemaObjectUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(schemaObject),
  });
};

export const getCreateSchemaObjectQueryKey = (schemaObject?: SchemaObject) => {
  return ["POST", `/schema-registry-service/v1/schema`, schemaObject] as const;
};

export const getCreateSchemaObjectQueryOptions = <
  TData = Awaited<ReturnType<typeof createSchemaObject>>,
  TError = CreateSchemaObject400,
>(
  schemaObject: SchemaObject,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSchemaObject>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCreateSchemaObjectQueryKey(schemaObject);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof createSchemaObject>>> = ({ signal }) =>
    createSchemaObject(schemaObject, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof createSchemaObject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CreateSchemaObjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof createSchemaObject>>
>;
export type CreateSchemaObjectQueryError = CreateSchemaObject400;

export function useCreateSchemaObject<
  TData = Awaited<ReturnType<typeof createSchemaObject>>,
  TError = CreateSchemaObject400,
>(
  schemaObject: SchemaObject,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSchemaObject>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createSchemaObject>>,
          TError,
          Awaited<ReturnType<typeof createSchemaObject>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateSchemaObject<
  TData = Awaited<ReturnType<typeof createSchemaObject>>,
  TError = CreateSchemaObject400,
>(
  schemaObject: SchemaObject,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof createSchemaObject>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createSchemaObject>>,
          TError,
          Awaited<ReturnType<typeof createSchemaObject>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCreateSchemaObject<
  TData = Awaited<ReturnType<typeof createSchemaObject>>,
  TError = CreateSchemaObject400,
>(
  schemaObject: SchemaObject,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSchemaObject>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Create a new schema
 */

export function useCreateSchemaObject<
  TData = Awaited<ReturnType<typeof createSchemaObject>>,
  TError = CreateSchemaObject400,
>(
  schemaObject: SchemaObject,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof createSchemaObject>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCreateSchemaObjectQueryOptions(schemaObject, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getSchemaObjectVersionsResponse200 = {
  data: SchemaObject[];
  status: 200;
};

export type getSchemaObjectVersionsResponse404 = {
  data: void;
  status: 404;
};

export type getSchemaObjectVersionsResponseSuccess = getSchemaObjectVersionsResponse200 & {
  headers: Headers;
};
export type getSchemaObjectVersionsResponseError = getSchemaObjectVersionsResponse404 & {
  headers: Headers;
};

export type getSchemaObjectVersionsResponse =
  | getSchemaObjectVersionsResponseSuccess
  | getSchemaObjectVersionsResponseError;

export const getGetSchemaObjectVersionsUrl = (resource: string) => {
  return `/schema-registry-service/v1/schema/${resource}`;
};

/**
 * @summary Get all versions for a schema object
 */
export const getSchemaObjectVersions = async (
  resource: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getSchemaObjectVersionsResponse> => {
  return customFetch<getSchemaObjectVersionsResponse>(getGetSchemaObjectVersionsUrl(resource), {
    ...options,
    method: "GET",
  });
};

export const getGetSchemaObjectVersionsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getSchemaObjectVersions>>,
    TError,
    { resource: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getSchemaObjectVersions>>,
  TError,
  { resource: string },
  TContext
> => {
  const mutationKey = ["getSchemaObjectVersions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getSchemaObjectVersions>>,
    { resource: string }
  > = (props) => {
    const { resource } = props ?? {};

    return getSchemaObjectVersions(resource, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetSchemaObjectVersionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getSchemaObjectVersions>>
>;

export type GetSchemaObjectVersionsMutationError = void;

/**
 * @summary Get all versions for a schema object
 */
export const useGetSchemaObjectVersions = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getSchemaObjectVersions>>,
      TError,
      { resource: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getSchemaObjectVersions>>,
  TError,
  { resource: string },
  TContext
> => {
  return useMutation(getGetSchemaObjectVersionsMutationOptions(options), queryClient);
};
export type getSchemaObjectByVersionResponse200 = {
  data: SchemaObject | UiLens;
  status: 200;
};

export type getSchemaObjectByVersionResponse404 = {
  data: void;
  status: 404;
};

export type getSchemaObjectByVersionResponseSuccess = getSchemaObjectByVersionResponse200 & {
  headers: Headers;
};
export type getSchemaObjectByVersionResponseError = getSchemaObjectByVersionResponse404 & {
  headers: Headers;
};

export type getSchemaObjectByVersionResponse =
  | getSchemaObjectByVersionResponseSuccess
  | getSchemaObjectByVersionResponseError;

export const getGetSchemaObjectByVersionUrl = (
  resource: string,
  resourceVersion: string,
  params?: GetSchemaObjectByVersionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/schema-registry-service/v1/schema/${resource}/${resourceVersion}?${stringifiedParams}`
    : `/schema-registry-service/v1/schema/${resource}/${resourceVersion}`;
};

/**
 * @summary Get a schema by Id
 */
export const getSchemaObjectByVersion = async (
  resource: string,
  resourceVersion: string,
  params?: GetSchemaObjectByVersionParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getSchemaObjectByVersionResponse> => {
  return customFetch<getSchemaObjectByVersionResponse>(
    getGetSchemaObjectByVersionUrl(resource, resourceVersion, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSchemaObjectByVersionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getSchemaObjectByVersion>>,
    TError,
    { resource: string; resourceVersion: string; params?: GetSchemaObjectByVersionParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getSchemaObjectByVersion>>,
  TError,
  { resource: string; resourceVersion: string; params?: GetSchemaObjectByVersionParams },
  TContext
> => {
  const mutationKey = ["getSchemaObjectByVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getSchemaObjectByVersion>>,
    { resource: string; resourceVersion: string; params?: GetSchemaObjectByVersionParams }
  > = (props) => {
    const { resource, resourceVersion, params } = props ?? {};

    return getSchemaObjectByVersion(resource, resourceVersion, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetSchemaObjectByVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof getSchemaObjectByVersion>>
>;

export type GetSchemaObjectByVersionMutationError = void;

/**
 * @summary Get a schema by Id
 */
export const useGetSchemaObjectByVersion = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getSchemaObjectByVersion>>,
      TError,
      { resource: string; resourceVersion: string; params?: GetSchemaObjectByVersionParams },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getSchemaObjectByVersion>>,
  TError,
  { resource: string; resourceVersion: string; params?: GetSchemaObjectByVersionParams },
  TContext
> => {
  return useMutation(getGetSchemaObjectByVersionMutationOptions(options), queryClient);
};
export type updateSchemaObjectByVersionResponse200 = {
  data: UpdateSchemaObjectByVersion200;
  status: 200;
};

export type updateSchemaObjectByVersionResponse404 = {
  data: void;
  status: 404;
};

export type updateSchemaObjectByVersionResponseSuccess = updateSchemaObjectByVersionResponse200 & {
  headers: Headers;
};
export type updateSchemaObjectByVersionResponseError = updateSchemaObjectByVersionResponse404 & {
  headers: Headers;
};

export type updateSchemaObjectByVersionResponse =
  | updateSchemaObjectByVersionResponseSuccess
  | updateSchemaObjectByVersionResponseError;

export const getUpdateSchemaObjectByVersionUrl = (
  resource: string,
  resourceVersion: string,
  params?: UpdateSchemaObjectByVersionParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/schema-registry-service/v1/schema/${resource}/${resourceVersion}?${stringifiedParams}`
    : `/schema-registry-service/v1/schema/${resource}/${resourceVersion}`;
};

/**
 * @summary Update a schema by name
 */
export const updateSchemaObjectByVersion = async (
  resource: string,
  resourceVersion: string,
  schemaObjectUiLensDraft: SchemaObject | UiLensDraft,
  params?: UpdateSchemaObjectByVersionParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<updateSchemaObjectByVersionResponse> => {
  return customFetch<updateSchemaObjectByVersionResponse>(
    getUpdateSchemaObjectByVersionUrl(resource, resourceVersion, params),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(schemaObjectUiLensDraft),
    },
  );
};

export const getUpdateSchemaObjectByVersionQueryKey = (
  resource: string,
  resourceVersion: string,
  schemaObjectUiLensDraft?: SchemaObject | UiLensDraft,
  params?: UpdateSchemaObjectByVersionParams,
) => {
  return [
    "PUT",
    `/schema-registry-service/v1/schema/${resource}/${resourceVersion}`,
    ...(params ? [params] : []),
    schemaObjectUiLensDraft,
  ] as const;
};

export const getUpdateSchemaObjectByVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof updateSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  schemaObjectUiLensDraft: SchemaObject | UiLensDraft,
  params?: UpdateSchemaObjectByVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateSchemaObjectByVersion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUpdateSchemaObjectByVersionQueryKey(
      resource,
      resourceVersion,
      schemaObjectUiLensDraft,
      params,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updateSchemaObjectByVersion>>> = ({
    signal,
  }) =>
    updateSchemaObjectByVersion(resource, resourceVersion, schemaObjectUiLensDraft, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof updateSchemaObjectByVersion>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type UpdateSchemaObjectByVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof updateSchemaObjectByVersion>>
>;
export type UpdateSchemaObjectByVersionQueryError = void;

export function useUpdateSchemaObjectByVersion<
  TData = Awaited<ReturnType<typeof updateSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  schemaObjectUiLensDraft: SchemaObject | UiLensDraft,
  params: undefined | UpdateSchemaObjectByVersionParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateSchemaObjectByVersion>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateSchemaObjectByVersion>>,
          TError,
          Awaited<ReturnType<typeof updateSchemaObjectByVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateSchemaObjectByVersion<
  TData = Awaited<ReturnType<typeof updateSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  schemaObjectUiLensDraft: SchemaObject | UiLensDraft,
  params?: UpdateSchemaObjectByVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateSchemaObjectByVersion>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateSchemaObjectByVersion>>,
          TError,
          Awaited<ReturnType<typeof updateSchemaObjectByVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateSchemaObjectByVersion<
  TData = Awaited<ReturnType<typeof updateSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  schemaObjectUiLensDraft: SchemaObject | UiLensDraft,
  params?: UpdateSchemaObjectByVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateSchemaObjectByVersion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update a schema by name
 */

export function useUpdateSchemaObjectByVersion<
  TData = Awaited<ReturnType<typeof updateSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  schemaObjectUiLensDraft: SchemaObject | UiLensDraft,
  params?: UpdateSchemaObjectByVersionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateSchemaObjectByVersion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdateSchemaObjectByVersionQueryOptions(
    resource,
    resourceVersion,
    schemaObjectUiLensDraft,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteSchemaObjectByVersionResponse204 = {
  data: void;
  status: 204;
};

export type deleteSchemaObjectByVersionResponse404 = {
  data: void;
  status: 404;
};

export type deleteSchemaObjectByVersionResponseSuccess = deleteSchemaObjectByVersionResponse204 & {
  headers: Headers;
};
export type deleteSchemaObjectByVersionResponseError = deleteSchemaObjectByVersionResponse404 & {
  headers: Headers;
};

export type deleteSchemaObjectByVersionResponse =
  | deleteSchemaObjectByVersionResponseSuccess
  | deleteSchemaObjectByVersionResponseError;

export const getDeleteSchemaObjectByVersionUrl = (resource: string, resourceVersion: string) => {
  return `/schema-registry-service/v1/schema/${resource}/${resourceVersion}`;
};

/**
 * @summary Delete a schema by name
 */
export const deleteSchemaObjectByVersion = async (
  resource: string,
  resourceVersion: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<deleteSchemaObjectByVersionResponse> => {
  return customFetch<deleteSchemaObjectByVersionResponse>(
    getDeleteSchemaObjectByVersionUrl(resource, resourceVersion),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteSchemaObjectByVersionQueryKey = (
  resource: string,
  resourceVersion: string,
) => {
  return ["DELETE", `/schema-registry-service/v1/schema/${resource}/${resourceVersion}`] as const;
};

export const getDeleteSchemaObjectByVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDeleteSchemaObjectByVersionQueryKey(resource, resourceVersion);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>> = ({
    signal,
  }) => deleteSchemaObjectByVersion(resource, resourceVersion, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DeleteSchemaObjectByVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>
>;
export type DeleteSchemaObjectByVersionQueryError = void;

export function useDeleteSchemaObjectByVersion<
  TData = Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>,
          TError,
          Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteSchemaObjectByVersion<
  TData = Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>,
          TError,
          Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteSchemaObjectByVersion<
  TData = Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete a schema by name
 */

export function useDeleteSchemaObjectByVersion<
  TData = Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaObjectByVersion>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDeleteSchemaObjectByVersionQueryOptions(
    resource,
    resourceVersion,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getSpecializationFamilyResponse200 = {
  data: GetSpecializationFamily200;
  status: 200;
};

export type getSpecializationFamilyResponse404 = {
  data: void;
  status: 404;
};

export type getSpecializationFamilyResponseSuccess = getSpecializationFamilyResponse200 & {
  headers: Headers;
};
export type getSpecializationFamilyResponseError = getSpecializationFamilyResponse404 & {
  headers: Headers;
};

export type getSpecializationFamilyResponse =
  | getSpecializationFamilyResponseSuccess
  | getSpecializationFamilyResponseError;

export const getGetSpecializationFamilyUrl = (rootResource: string) => {
  return `/schema-registry-service/v1/schema/specialization-family/${rootResource}`;
};

/**
 * Returns the list of resource names whose schemas declare
 * x-typed-specialization-of.rootResources containing the given rootResource.
 * A specialization may declare multiple roots (e.g. `[Material, MaterialIntent]`)
 * so the same schema can appear in more than one root's family.
 * Used by the relationship constraint resolver to build the polymorphic
 * target set for typed-specialization cardinality and immutability checks.
 * @summary Discover all specialization schemas for a type-root resource
 */
export const getSpecializationFamily = async (
  rootResource: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getSpecializationFamilyResponse> => {
  return customFetch<getSpecializationFamilyResponse>(getGetSpecializationFamilyUrl(rootResource), {
    ...options,
    method: "GET",
  });
};

export const getGetSpecializationFamilyMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getSpecializationFamily>>,
    TError,
    { rootResource: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getSpecializationFamily>>,
  TError,
  { rootResource: string },
  TContext
> => {
  const mutationKey = ["getSpecializationFamily"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getSpecializationFamily>>,
    { rootResource: string }
  > = (props) => {
    const { rootResource } = props ?? {};

    return getSpecializationFamily(rootResource, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetSpecializationFamilyMutationResult = NonNullable<
  Awaited<ReturnType<typeof getSpecializationFamily>>
>;

export type GetSpecializationFamilyMutationError = void;

/**
 * @summary Discover all specialization schemas for a type-root resource
 */
export const useGetSpecializationFamily = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getSpecializationFamily>>,
      TError,
      { rootResource: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getSpecializationFamily>>,
  TError,
  { rootResource: string },
  TContext
> => {
  return useMutation(getGetSpecializationFamilyMutationOptions(options), queryClient);
};
export type getTypeMatrixResponse200 = {
  data: TypeMatrix;
  status: 200;
};

export type getTypeMatrixResponse404 = {
  data: void;
  status: 404;
};

export type getTypeMatrixResponseSuccess = getTypeMatrixResponse200 & {
  headers: Headers;
};
export type getTypeMatrixResponseError = getTypeMatrixResponse404 & {
  headers: Headers;
};

export type getTypeMatrixResponse = getTypeMatrixResponseSuccess | getTypeMatrixResponseError;

export const getGetTypeMatrixUrl = (rootResource: string) => {
  return `/schema-registry-service/v1/schema/type-matrix/${rootResource}`;
};

/**
 * Read-only projection of all specialization schemas and their feature flags.
 * Replaces the monolith MaterialTypeConfiguration boolean matrix.
 * Queries all schemas where the given rootResource appears in
 * x-typed-specialization-of.rootResources, extracts properties and
 * x-feature-flags from each, and assembles the matrix. A specialization
 * that lists multiple roots appears in each root's matrix.
 * @summary Derive the type configuration matrix for a type-root resource
 */
export const getTypeMatrix = async (
  rootResource: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getTypeMatrixResponse> => {
  return customFetch<getTypeMatrixResponse>(getGetTypeMatrixUrl(rootResource), {
    ...options,
    method: "GET",
  });
};

export const getGetTypeMatrixMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getTypeMatrix>>,
    TError,
    { rootResource: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getTypeMatrix>>,
  TError,
  { rootResource: string },
  TContext
> => {
  const mutationKey = ["getTypeMatrix"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getTypeMatrix>>,
    { rootResource: string }
  > = (props) => {
    const { rootResource } = props ?? {};

    return getTypeMatrix(rootResource, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetTypeMatrixMutationResult = NonNullable<Awaited<ReturnType<typeof getTypeMatrix>>>;

export type GetTypeMatrixMutationError = void;

/**
 * @summary Derive the type configuration matrix for a type-root resource
 */
export const useGetTypeMatrix = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getTypeMatrix>>,
      TError,
      { rootResource: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getTypeMatrix>>,
  TError,
  { rootResource: string },
  TContext
> => {
  return useMutation(getGetTypeMatrixMutationOptions(options), queryClient);
};
export type getSchemaObjectViewsResponse200 = {
  data: ViewList;
  status: 200;
};

export type getSchemaObjectViewsResponse404 = {
  data: void;
  status: 404;
};

export type getSchemaObjectViewsResponseSuccess = getSchemaObjectViewsResponse200 & {
  headers: Headers;
};
export type getSchemaObjectViewsResponseError = getSchemaObjectViewsResponse404 & {
  headers: Headers;
};

export type getSchemaObjectViewsResponse =
  | getSchemaObjectViewsResponseSuccess
  | getSchemaObjectViewsResponseError;

export const getGetSchemaObjectViewsUrl = (
  resource: string,
  resourceVersion: string,
  params?: GetSchemaObjectViewsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/views?${stringifiedParams}`
    : `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/views`;
};

/**
 * @summary Get all views for a schema
 */
export const getSchemaObjectViews = async (
  resource: string,
  resourceVersion: string,
  params?: GetSchemaObjectViewsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<getSchemaObjectViewsResponse> => {
  return customFetch<getSchemaObjectViewsResponse>(
    getGetSchemaObjectViewsUrl(resource, resourceVersion, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSchemaObjectViewsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getSchemaObjectViews>>,
    TError,
    { resource: string; resourceVersion: string; params?: GetSchemaObjectViewsParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getSchemaObjectViews>>,
  TError,
  { resource: string; resourceVersion: string; params?: GetSchemaObjectViewsParams },
  TContext
> => {
  const mutationKey = ["getSchemaObjectViews"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getSchemaObjectViews>>,
    { resource: string; resourceVersion: string; params?: GetSchemaObjectViewsParams }
  > = (props) => {
    const { resource, resourceVersion, params } = props ?? {};

    return getSchemaObjectViews(resource, resourceVersion, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetSchemaObjectViewsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getSchemaObjectViews>>
>;

export type GetSchemaObjectViewsMutationError = void;

/**
 * @summary Get all views for a schema
 */
export const useGetSchemaObjectViews = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getSchemaObjectViews>>,
      TError,
      { resource: string; resourceVersion: string; params?: GetSchemaObjectViewsParams },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getSchemaObjectViews>>,
  TError,
  { resource: string; resourceVersion: string; params?: GetSchemaObjectViewsParams },
  TContext
> => {
  return useMutation(getGetSchemaObjectViewsMutationOptions(options), queryClient);
};
export type deleteSchemaViewBundleResponse204 = {
  data: void;
  status: 204;
};

export type deleteSchemaViewBundleResponse400 = {
  data: void;
  status: 400;
};

export type deleteSchemaViewBundleResponse404 = {
  data: void;
  status: 404;
};

export type deleteSchemaViewBundleResponseSuccess = deleteSchemaViewBundleResponse204 & {
  headers: Headers;
};
export type deleteSchemaViewBundleResponseError = (
  | deleteSchemaViewBundleResponse400
  | deleteSchemaViewBundleResponse404
) & {
  headers: Headers;
};

export type deleteSchemaViewBundleResponse =
  | deleteSchemaViewBundleResponseSuccess
  | deleteSchemaViewBundleResponseError;

export const getDeleteSchemaViewBundleUrl = (
  resource: string,
  resourceVersion: string,
  viewName: string,
) => {
  return `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/views/${viewName}`;
};

/**
 * @summary Delete a named view bundle (root and edge target rows)
 */
export const deleteSchemaViewBundle = async (
  resource: string,
  resourceVersion: string,
  viewName: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<deleteSchemaViewBundleResponse> => {
  return customFetch<deleteSchemaViewBundleResponse>(
    getDeleteSchemaViewBundleUrl(resource, resourceVersion, viewName),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteSchemaViewBundleQueryKey = (
  resource: string,
  resourceVersion: string,
  viewName: string,
) => {
  return [
    "DELETE",
    `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/views/${viewName}`,
  ] as const;
};

export const getDeleteSchemaViewBundleQueryOptions = <
  TData = Awaited<ReturnType<typeof deleteSchemaViewBundle>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  viewName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaViewBundle>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDeleteSchemaViewBundleQueryKey(resource, resourceVersion, viewName);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteSchemaViewBundle>>> = ({ signal }) =>
    deleteSchemaViewBundle(resource, resourceVersion, viewName, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      viewName !== null &&
      viewName !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaViewBundle>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type DeleteSchemaViewBundleQueryResult = NonNullable<
  Awaited<ReturnType<typeof deleteSchemaViewBundle>>
>;
export type DeleteSchemaViewBundleQueryError = void;

export function useDeleteSchemaViewBundle<
  TData = Awaited<ReturnType<typeof deleteSchemaViewBundle>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  viewName: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaViewBundle>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteSchemaViewBundle>>,
          TError,
          Awaited<ReturnType<typeof deleteSchemaViewBundle>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteSchemaViewBundle<
  TData = Awaited<ReturnType<typeof deleteSchemaViewBundle>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  viewName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaViewBundle>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteSchemaViewBundle>>,
          TError,
          Awaited<ReturnType<typeof deleteSchemaViewBundle>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteSchemaViewBundle<
  TData = Awaited<ReturnType<typeof deleteSchemaViewBundle>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  viewName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaViewBundle>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete a named view bundle (root and edge target rows)
 */

export function useDeleteSchemaViewBundle<
  TData = Awaited<ReturnType<typeof deleteSchemaViewBundle>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  viewName: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteSchemaViewBundle>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDeleteSchemaViewBundleQueryOptions(
    resource,
    resourceVersion,
    viewName,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getAllRelationshipsForSchemaResponse200 = {
  data: Relationships;
  status: 200;
};

export type getAllRelationshipsForSchemaResponse404 = {
  data: void;
  status: 404;
};

export type getAllRelationshipsForSchemaResponseSuccess =
  getAllRelationshipsForSchemaResponse200 & {
    headers: Headers;
  };
export type getAllRelationshipsForSchemaResponseError = getAllRelationshipsForSchemaResponse404 & {
  headers: Headers;
};

export type getAllRelationshipsForSchemaResponse =
  | getAllRelationshipsForSchemaResponseSuccess
  | getAllRelationshipsForSchemaResponseError;

export const getGetAllRelationshipsForSchemaUrl = (resource: string, resourceVersion: string) => {
  return `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/relationships`;
};

/**
 * @summary Get all relationships for a schema
 */
export const getAllRelationshipsForSchema = async (
  resource: string,
  resourceVersion: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getAllRelationshipsForSchemaResponse> => {
  return customFetch<getAllRelationshipsForSchemaResponse>(
    getGetAllRelationshipsForSchemaUrl(resource, resourceVersion),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAllRelationshipsForSchemaMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAllRelationshipsForSchema>>,
    TError,
    { resource: string; resourceVersion: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAllRelationshipsForSchema>>,
  TError,
  { resource: string; resourceVersion: string },
  TContext
> => {
  const mutationKey = ["getAllRelationshipsForSchema"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAllRelationshipsForSchema>>,
    { resource: string; resourceVersion: string }
  > = (props) => {
    const { resource, resourceVersion } = props ?? {};

    return getAllRelationshipsForSchema(resource, resourceVersion, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAllRelationshipsForSchemaMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAllRelationshipsForSchema>>
>;

export type GetAllRelationshipsForSchemaMutationError = void;

/**
 * @summary Get all relationships for a schema
 */
export const useGetAllRelationshipsForSchema = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAllRelationshipsForSchema>>,
      TError,
      { resource: string; resourceVersion: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getAllRelationshipsForSchema>>,
  TError,
  { resource: string; resourceVersion: string },
  TContext
> => {
  return useMutation(getGetAllRelationshipsForSchemaMutationOptions(options), queryClient);
};
export type getRelationshipForSchemaByRelationshipNameResponse200 = {
  data: Relationships;
  status: 200;
};

export type getRelationshipForSchemaByRelationshipNameResponse404 = {
  data: void;
  status: 404;
};

export type getRelationshipForSchemaByRelationshipNameResponseSuccess =
  getRelationshipForSchemaByRelationshipNameResponse200 & {
    headers: Headers;
  };
export type getRelationshipForSchemaByRelationshipNameResponseError =
  getRelationshipForSchemaByRelationshipNameResponse404 & {
    headers: Headers;
  };

export type getRelationshipForSchemaByRelationshipNameResponse =
  | getRelationshipForSchemaByRelationshipNameResponseSuccess
  | getRelationshipForSchemaByRelationshipNameResponseError;

export const getGetRelationshipForSchemaByRelationshipNameUrl = (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
) => {
  return `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/relationships/${relationshipName}`;
};

/**
 * @summary Get relationship information for a specific relationship type
 */
export const getRelationshipForSchemaByRelationshipName = async (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getRelationshipForSchemaByRelationshipNameResponse> => {
  return customFetch<getRelationshipForSchemaByRelationshipNameResponse>(
    getGetRelationshipForSchemaByRelationshipNameUrl(resource, resourceVersion, relationshipName),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRelationshipForSchemaByRelationshipNameMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRelationshipForSchemaByRelationshipName>>,
    TError,
    { resource: string; resourceVersion: string; relationshipName: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRelationshipForSchemaByRelationshipName>>,
  TError,
  { resource: string; resourceVersion: string; relationshipName: string },
  TContext
> => {
  const mutationKey = ["getRelationshipForSchemaByRelationshipName"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRelationshipForSchemaByRelationshipName>>,
    { resource: string; resourceVersion: string; relationshipName: string }
  > = (props) => {
    const { resource, resourceVersion, relationshipName } = props ?? {};

    return getRelationshipForSchemaByRelationshipName(
      resource,
      resourceVersion,
      relationshipName,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRelationshipForSchemaByRelationshipNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRelationshipForSchemaByRelationshipName>>
>;

export type GetRelationshipForSchemaByRelationshipNameMutationError = void;

/**
 * @summary Get relationship information for a specific relationship type
 */
export const useGetRelationshipForSchemaByRelationshipName = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRelationshipForSchemaByRelationshipName>>,
      TError,
      { resource: string; resourceVersion: string; relationshipName: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRelationshipForSchemaByRelationshipName>>,
  TError,
  { resource: string; resourceVersion: string; relationshipName: string },
  TContext
> => {
  return useMutation(
    getGetRelationshipForSchemaByRelationshipNameMutationOptions(options),
    queryClient,
  );
};
export type getRelationshipsForSchemaByTypeAndVersionResponse200 = {
  data: Relationship;
  status: 200;
};

export type getRelationshipsForSchemaByTypeAndVersionResponse404 = {
  data: void;
  status: 404;
};

export type getRelationshipsForSchemaByTypeAndVersionResponseSuccess =
  getRelationshipsForSchemaByTypeAndVersionResponse200 & {
    headers: Headers;
  };
export type getRelationshipsForSchemaByTypeAndVersionResponseError =
  getRelationshipsForSchemaByTypeAndVersionResponse404 & {
    headers: Headers;
  };

export type getRelationshipsForSchemaByTypeAndVersionResponse =
  | getRelationshipsForSchemaByTypeAndVersionResponseSuccess
  | getRelationshipsForSchemaByTypeAndVersionResponseError;

export const getGetRelationshipsForSchemaByTypeAndVersionUrl = (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
) => {
  return `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/relationships/${relationshipName}/${relationshipVersion}`;
};

/**
 * @summary Get relationships of a specific type and version for a schema
 */
export const getRelationshipsForSchemaByTypeAndVersion = async (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getRelationshipsForSchemaByTypeAndVersionResponse> => {
  return customFetch<getRelationshipsForSchemaByTypeAndVersionResponse>(
    getGetRelationshipsForSchemaByTypeAndVersionUrl(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
    ),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetRelationshipsForSchemaByTypeAndVersionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getRelationshipsForSchemaByTypeAndVersion>>,
    TError,
    {
      resource: string;
      resourceVersion: string;
      relationshipName: string;
      relationshipVersion: string;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getRelationshipsForSchemaByTypeAndVersion>>,
  TError,
  {
    resource: string;
    resourceVersion: string;
    relationshipName: string;
    relationshipVersion: string;
  },
  TContext
> => {
  const mutationKey = ["getRelationshipsForSchemaByTypeAndVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getRelationshipsForSchemaByTypeAndVersion>>,
    {
      resource: string;
      resourceVersion: string;
      relationshipName: string;
      relationshipVersion: string;
    }
  > = (props) => {
    const { resource, resourceVersion, relationshipName, relationshipVersion } = props ?? {};

    return getRelationshipsForSchemaByTypeAndVersion(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetRelationshipsForSchemaByTypeAndVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof getRelationshipsForSchemaByTypeAndVersion>>
>;

export type GetRelationshipsForSchemaByTypeAndVersionMutationError = void;

/**
 * @summary Get relationships of a specific type and version for a schema
 */
export const useGetRelationshipsForSchemaByTypeAndVersion = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getRelationshipsForSchemaByTypeAndVersion>>,
      TError,
      {
        resource: string;
        resourceVersion: string;
        relationshipName: string;
        relationshipVersion: string;
      },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getRelationshipsForSchemaByTypeAndVersion>>,
  TError,
  {
    resource: string;
    resourceVersion: string;
    relationshipName: string;
    relationshipVersion: string;
  },
  TContext
> => {
  return useMutation(
    getGetRelationshipsForSchemaByTypeAndVersionMutationOptions(options),
    queryClient,
  );
};
export type addRelationshipsForSchemaResponse201 = {
  data: Relationship;
  status: 201;
};

export type addRelationshipsForSchemaResponse400 = {
  data: void;
  status: 400;
};

export type addRelationshipsForSchemaResponse404 = {
  data: void;
  status: 404;
};

export type addRelationshipsForSchemaResponseSuccess = addRelationshipsForSchemaResponse201 & {
  headers: Headers;
};
export type addRelationshipsForSchemaResponseError = (
  | addRelationshipsForSchemaResponse400
  | addRelationshipsForSchemaResponse404
) & {
  headers: Headers;
};

export type addRelationshipsForSchemaResponse =
  | addRelationshipsForSchemaResponseSuccess
  | addRelationshipsForSchemaResponseError;

export const getAddRelationshipsForSchemaUrl = (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
) => {
  return `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/relationships/${relationshipName}/${relationshipVersion}`;
};

/**
 * @summary Add relationships to a schema
 */
export const addRelationshipsForSchema = async (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<addRelationshipsForSchemaResponse> => {
  return customFetch<addRelationshipsForSchemaResponse>(
    getAddRelationshipsForSchemaUrl(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
    ),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(relationshipConstraintsRequest),
    },
  );
};

export const getAddRelationshipsForSchemaQueryKey = (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest?: RelationshipConstraintsRequest,
) => {
  return [
    "POST",
    `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/relationships/${relationshipName}/${relationshipVersion}`,
    relationshipConstraintsRequest,
  ] as const;
};

export const getAddRelationshipsForSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof addRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addRelationshipsForSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAddRelationshipsForSchemaQueryKey(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
      relationshipConstraintsRequest,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addRelationshipsForSchema>>> = ({
    signal,
  }) =>
    addRelationshipsForSchema(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
      relationshipConstraintsRequest,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      relationshipName !== null &&
      relationshipName !== undefined &&
      relationshipVersion !== null &&
      relationshipVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof addRelationshipsForSchema>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type AddRelationshipsForSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof addRelationshipsForSchema>>
>;
export type AddRelationshipsForSchemaQueryError = void;

export function useAddRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof addRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addRelationshipsForSchema>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addRelationshipsForSchema>>,
          TError,
          Awaited<ReturnType<typeof addRelationshipsForSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof addRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addRelationshipsForSchema>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addRelationshipsForSchema>>,
          TError,
          Awaited<ReturnType<typeof addRelationshipsForSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAddRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof addRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addRelationshipsForSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Add relationships to a schema
 */

export function useAddRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof addRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addRelationshipsForSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAddRelationshipsForSchemaQueryOptions(
    resource,
    resourceVersion,
    relationshipName,
    relationshipVersion,
    relationshipConstraintsRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type updateRelationshipsForSchemaResponse200 = {
  data: Relationship;
  status: 200;
};

export type updateRelationshipsForSchemaResponse400 = {
  data: void;
  status: 400;
};

export type updateRelationshipsForSchemaResponse404 = {
  data: void;
  status: 404;
};

export type updateRelationshipsForSchemaResponseSuccess =
  updateRelationshipsForSchemaResponse200 & {
    headers: Headers;
  };
export type updateRelationshipsForSchemaResponseError = (
  | updateRelationshipsForSchemaResponse400
  | updateRelationshipsForSchemaResponse404
) & {
  headers: Headers;
};

export type updateRelationshipsForSchemaResponse =
  | updateRelationshipsForSchemaResponseSuccess
  | updateRelationshipsForSchemaResponseError;

export const getUpdateRelationshipsForSchemaUrl = (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
) => {
  return `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/relationships/${relationshipName}/${relationshipVersion}`;
};

/**
 * @summary Update relationships for a schema
 */
export const updateRelationshipsForSchema = async (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<updateRelationshipsForSchemaResponse> => {
  return customFetch<updateRelationshipsForSchemaResponse>(
    getUpdateRelationshipsForSchemaUrl(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
    ),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(relationshipConstraintsRequest),
    },
  );
};

export const getUpdateRelationshipsForSchemaQueryKey = (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest?: RelationshipConstraintsRequest,
) => {
  return [
    "PUT",
    `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/relationships/${relationshipName}/${relationshipVersion}`,
    relationshipConstraintsRequest,
  ] as const;
};

export const getUpdateRelationshipsForSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof updateRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipsForSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUpdateRelationshipsForSchemaQueryKey(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
      relationshipConstraintsRequest,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updateRelationshipsForSchema>>> = ({
    signal,
  }) =>
    updateRelationshipsForSchema(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
      relationshipConstraintsRequest,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      relationshipName !== null &&
      relationshipName !== undefined &&
      relationshipVersion !== null &&
      relationshipVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipsForSchema>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type UpdateRelationshipsForSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof updateRelationshipsForSchema>>
>;
export type UpdateRelationshipsForSchemaQueryError = void;

export function useUpdateRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof updateRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipsForSchema>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateRelationshipsForSchema>>,
          TError,
          Awaited<ReturnType<typeof updateRelationshipsForSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof updateRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipsForSchema>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateRelationshipsForSchema>>,
          TError,
          Awaited<ReturnType<typeof updateRelationshipsForSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof updateRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipsForSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update relationships for a schema
 */

export function useUpdateRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof updateRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  relationshipConstraintsRequest: RelationshipConstraintsRequest,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof updateRelationshipsForSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdateRelationshipsForSchemaQueryOptions(
    resource,
    resourceVersion,
    relationshipName,
    relationshipVersion,
    relationshipConstraintsRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteAllRelationshipsForSchemaResponse204 = {
  data: void;
  status: 204;
};

export type deleteAllRelationshipsForSchemaResponse404 = {
  data: void;
  status: 404;
};

export type deleteAllRelationshipsForSchemaResponseSuccess =
  deleteAllRelationshipsForSchemaResponse204 & {
    headers: Headers;
  };
export type deleteAllRelationshipsForSchemaResponseError =
  deleteAllRelationshipsForSchemaResponse404 & {
    headers: Headers;
  };

export type deleteAllRelationshipsForSchemaResponse =
  | deleteAllRelationshipsForSchemaResponseSuccess
  | deleteAllRelationshipsForSchemaResponseError;

export const getDeleteAllRelationshipsForSchemaUrl = (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
) => {
  return `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/relationships/${relationshipName}/${relationshipVersion}`;
};

/**
 * @summary Delete all relationships for a schema
 */
export const deleteAllRelationshipsForSchema = async (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<deleteAllRelationshipsForSchemaResponse> => {
  return customFetch<deleteAllRelationshipsForSchemaResponse>(
    getDeleteAllRelationshipsForSchemaUrl(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
    ),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteAllRelationshipsForSchemaQueryKey = (
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
) => {
  return [
    "DELETE",
    `/schema-registry-service/v1/schema/${resource}/${resourceVersion}/relationships/${relationshipName}/${relationshipVersion}`,
  ] as const;
};

export const getDeleteAllRelationshipsForSchemaQueryOptions = <
  TData = Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDeleteAllRelationshipsForSchemaQueryKey(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>> = ({
    signal,
  }) =>
    deleteAllRelationshipsForSchema(
      resource,
      resourceVersion,
      relationshipName,
      relationshipVersion,
      { signal, ...requestOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled:
      resource !== null &&
      resource !== undefined &&
      resourceVersion !== null &&
      resourceVersion !== undefined &&
      relationshipName !== null &&
      relationshipName !== undefined &&
      relationshipVersion !== null &&
      relationshipVersion !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DeleteAllRelationshipsForSchemaQueryResult = NonNullable<
  Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>
>;
export type DeleteAllRelationshipsForSchemaQueryError = void;

export function useDeleteAllRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>,
          TError,
          Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteAllRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>,
          TError,
          Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDeleteAllRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Delete all relationships for a schema
 */

export function useDeleteAllRelationshipsForSchema<
  TData = Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>,
  TError = void,
>(
  resource: string,
  resourceVersion: string,
  relationshipName: string,
  relationshipVersion: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof deleteAllRelationshipsForSchema>>, TError, TData>
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDeleteAllRelationshipsForSchemaQueryOptions(
    resource,
    resourceVersion,
    relationshipName,
    relationshipVersion,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getGraphPromotedPropertiesResponse200 = {
  data: GetGraphPromotedProperties200;
  status: 200;
};

export type getGraphPromotedPropertiesResponse404 = {
  data: void;
  status: 404;
};

export type getGraphPromotedPropertiesResponseSuccess = getGraphPromotedPropertiesResponse200 & {
  headers: Headers;
};
export type getGraphPromotedPropertiesResponseError = getGraphPromotedPropertiesResponse404 & {
  headers: Headers;
};

export type getGraphPromotedPropertiesResponse =
  | getGraphPromotedPropertiesResponseSuccess
  | getGraphPromotedPropertiesResponseError;

export const getGetGraphPromotedPropertiesUrl = (resource: string, version: string) => {
  return `/schema-registry-service/v1/graph-promoted-properties/${resource}/${version}`;
};

/**
 * @summary Get graph-promoted properties for a resource type and version
 */
export const getGraphPromotedProperties = async (
  resource: string,
  version: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<getGraphPromotedPropertiesResponse> => {
  return customFetch<getGraphPromotedPropertiesResponse>(
    getGetGraphPromotedPropertiesUrl(resource, version),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetGraphPromotedPropertiesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getGraphPromotedProperties>>,
    TError,
    { resource: string; version: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getGraphPromotedProperties>>,
  TError,
  { resource: string; version: string },
  TContext
> => {
  const mutationKey = ["getGraphPromotedProperties"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getGraphPromotedProperties>>,
    { resource: string; version: string }
  > = (props) => {
    const { resource, version } = props ?? {};

    return getGraphPromotedProperties(resource, version, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetGraphPromotedPropertiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof getGraphPromotedProperties>>
>;

export type GetGraphPromotedPropertiesMutationError = void;

/**
 * @summary Get graph-promoted properties for a resource type and version
 */
export const useGetGraphPromotedProperties = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getGraphPromotedProperties>>,
      TError,
      { resource: string; version: string },
      TContext
    >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getGraphPromotedProperties>>,
  TError,
  { resource: string; version: string },
  TContext
> => {
  return useMutation(getGetGraphPromotedPropertiesMutationOptions(options), queryClient);
};
export type promoteReleaseResponse202 = {
  data: PromoteRelease202;
  status: 202;
};

export type promoteReleaseResponse400 = {
  data: void;
  status: 400;
};

export type promoteReleaseResponse404 = {
  data: void;
  status: 404;
};

export type promoteReleaseResponseSuccess = promoteReleaseResponse202 & {
  headers: Headers;
};
export type promoteReleaseResponseError = (
  | promoteReleaseResponse400
  | promoteReleaseResponse404
) & {
  headers: Headers;
};

export type promoteReleaseResponse = promoteReleaseResponseSuccess | promoteReleaseResponseError;

export const getPromoteReleaseUrl = (releaseId: string) => {
  return `/schema-registry-service/v1/release/${releaseId}/promote`;
};

/**
 * @summary Promote a Release to target tenants (async)
 */
export const promoteRelease = async (
  releaseId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<promoteReleaseResponse> => {
  return customFetch<promoteReleaseResponse>(getPromoteReleaseUrl(releaseId), {
    ...options,
    method: "POST",
  });
};

export const getPromoteReleaseQueryKey = (releaseId: string) => {
  return ["POST", `/schema-registry-service/v1/release/${releaseId}/promote`] as const;
};

export const getPromoteReleaseQueryOptions = <
  TData = Awaited<ReturnType<typeof promoteRelease>>,
  TError = void,
>(
  releaseId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteRelease>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPromoteReleaseQueryKey(releaseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promoteRelease>>> = ({ signal }) =>
    promoteRelease(releaseId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: releaseId !== null && releaseId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof promoteRelease>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type PromoteReleaseQueryResult = NonNullable<Awaited<ReturnType<typeof promoteRelease>>>;
export type PromoteReleaseQueryError = void;

export function usePromoteRelease<
  TData = Awaited<ReturnType<typeof promoteRelease>>,
  TError = void,
>(
  releaseId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteRelease>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoteRelease>>,
          TError,
          Awaited<ReturnType<typeof promoteRelease>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePromoteRelease<
  TData = Awaited<ReturnType<typeof promoteRelease>>,
  TError = void,
>(
  releaseId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteRelease>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoteRelease>>,
          TError,
          Awaited<ReturnType<typeof promoteRelease>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePromoteRelease<
  TData = Awaited<ReturnType<typeof promoteRelease>>,
  TError = void,
>(
  releaseId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteRelease>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Promote a Release to target tenants (async)
 */

export function usePromoteRelease<
  TData = Awaited<ReturnType<typeof promoteRelease>>,
  TError = void,
>(
  releaseId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoteRelease>>, TError, TData>>;
    request?: SecondParameter<typeof customFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPromoteReleaseQueryOptions(releaseId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
